export default "__VITE_ASSET__DiYDrOkN__"